<template>
  <a-modal
      :visible="visible"
      :closable="false"
      @cancel="visible = false"
      :footer="null"
      :width="440"
  >
    <div class="header">
      <div>添加收藏</div>
      <a-button :disabled="is_add_cate" type="danger" shape="circle" icon="plus" size="small" style="margin-left: 8px;"
                @click="handleAddCate"/>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px;">

      <a-select
          v-model="formData.cid"
          placeholder="选择分类"
          style="width: 100%;"
      >
        <a-select-option v-for="cate in cates" :key="cate.id" :value="cate.id">
          {{ cate.name }}
        </a-select-option>
      </a-select>

      <a-form v-if="is_add_cate" layout="inline" :form="cateForm" style="margin-top: 10px;">
        <a-form-item>
          <a-input v-model="cateForm.name" placeholder="分类名">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" :disabled="cateForm.name.length === 0" @click="handleSubmitCate">
            确定
          </a-button>
          <a-button @click="is_add_cate = false" style="margin-left: 10px;">
            取消
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="footer">
      <a-button class="button confirm" :disabled="cateForm.is_add_cate || !formData.cid" @click="handleAddCollection">加入收藏</a-button>
      <a-button class="button" @click="visible = false">取消</a-button>
    </div>
  </a-modal>
</template>

<script>
import {fetchCollectionCate, editCollectionCate, addCollection} from '@/api/goods-list'

export default {
  name: "index",
  data() {
    return {
      visible: false,
      data: [],
      cates: [],
      is_add_cate: false,
      cateForm: {},
      formData: {},
      goods: undefined,
    }
  },
  beforeMount() {
  },
  methods: {
    show(goods) {
      const {good_id} = goods
      this.goods = goods
      console.log(goods)
      this.visible = true
      this.is_add_cate = false
      this.formData = {
        gid: good_id
      }
      this.fetchCates()
    },
    handleOk() {

    },
    fetchCates() {
      fetchCollectionCate(this.goods.provider).then(res => {
        console.log(res)
        this.cates = res
      })
    },
    handleAddCate() {
      this.is_add_cate = true
      this.cateForm = {
        name: ''
      }
    },
    handleSubmitCate() {
      editCollectionCate(this.cateForm, this.goods.provider).then(res => {
        console.log(res)
        this.is_add_cate = false
        this.fetchCates()
      })
    },
    handleAddCollection() {
      console.log(this.formData)
      addCollection(this.formData, this.goods.provider).then(res => {
        console.log(res)
        this.$message.success('商品加入收藏成功');
        this.visible = false
      })
    }

  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;

  font-weight: 500;
  color: #000000;
  line-height: 22px;

  .button-add {
    height: 32px;
    background: #E9F2FF;
    border-radius: 6px;
    border: 1px solid #1890FF;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1890FF;
    line-height: 20px;
  }
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;


  .button {
    width: 106px;
    height: 40px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    margin: 5px;
  }

  .confirm {
    color: #FFFFFF;
    background: #8D12F8;
  }
}
</style>
